import { useLocation } from "react-router-dom";
import CarrouselCategory from "../components/carrouselCategory/carrouselCategory";

export default function CarrouselCategoryPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const id = params.get("idEvent");
  const version= params.get("country");

  return(
    <CarrouselCategory id={id} version={version}/>
  )

}
